import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Button } from '@frontend/legacy-components';

import { markAllNotificationsRead } from '../data/actions';

const MarkAllNotificationsReadButton = ({ callback }) => {
  const dispatch = useDispatch();
  const markAllAsRead = useCallback(
    () => dispatch(markAllNotificationsRead.request({ callback })),
    [callback, dispatch],
  );

  return (
    <Button onClick={markAllAsRead} size="md" variant="link">
      Mark all as read
    </Button>
  );
};

export default MarkAllNotificationsReadButton;
